export { default } from "./hottest-discussions";
